import type { TypeFormFieldElement } from '../../../types/form';

// ----------------------------------------------------------------------------

function isFormFieldElement(element: Element): element is TypeFormFieldElement {
    return (
        element instanceof HTMLInputElement ||
        element instanceof HTMLSelectElement ||
        element instanceof HTMLTextAreaElement
    );
}

// ----------------------------------------------------------------------------

function getFormValues(form: HTMLFormElement): Record<string, unknown> {
    const values: Record<string, string | string[]> = {};

    const elements = Array.from(form.elements).filter(isFormFieldElement);

    for (const element of elements) {
        const name = element.name;

        if (!name) {
            continue;
        }

        //
        if (element instanceof HTMLInputElement) {
            //
            if (element.type === 'checkbox') {
                if (!Array.isArray(values[name])) {
                    values[name] = [];
                }

                if (element.checked) {
                    values[name].push(element.value);
                }
            }
            //
            else if (element.type === 'radio') {
                if (element.checked) {
                    values[name] = element.value;
                }
            }
            //
            else {
                values[name] = element.value;
            }
        }
        //
        else if (element instanceof HTMLSelectElement) {
            //
            if (element.multiple) {
                values[name] = Array.from(element.selectedOptions).map((o): any => o.value);
            }
            //
            else {
                values[name] = element.value;
            }
        }
        //
        else if (element instanceof HTMLTextAreaElement) {
            values[name] = element.value;
        }
    }

    return values;
}

// ----------------------------------------------------------------------------

export default getFormValues;
